import { Form, Head } from "@inertiajs/react"

import { FormField } from "@/components/form-field"
import { InputError } from "@/components/input-error"
import { TextLink } from "@/components/text-link"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Spinner } from "@/components/ui/spinner"
import AuthLayout from "@/layouts/auth-layout"
import { newIdentityPasswordResetPath, signInPath, signUpPath } from "@/routes"

export default function Login() {
  return (
    <AuthLayout
      title="Log in to your account"
      description="Enter your email and password below to log in"
    >
      <Head title="Log in" />
      <Form
        method="post"
        action={signInPath()}
        resetOnSuccess={["password"]}
        className="flex flex-col gap-6"
      >
        {({ processing, errors }) => (
          <>
            <div className="grid gap-6">
              <FormField
                label="Email address"
                htmlFor="email"
                error={errors.email?.join(", ")}
              >
                <Input
                  id="email"
                  name="email"
                  type="email"
                  required
                  autoFocus
                  autoComplete="email"
                  placeholder="email@example.com"
                />
              </FormField>

              <div className="grid gap-2">
                <div className="flex items-center">
                  <Label htmlFor="password">Password</Label>
                  <TextLink
                    href={newIdentityPasswordResetPath()}
                    className="ml-auto text-sm"
                  >
                    Forgot password?
                  </TextLink>
                </div>
                <Input
                  id="password"
                  type="password"
                  name="password"
                  required
                  autoComplete="current-password"
                  placeholder="Password"
                  aria-invalid={!!errors.password || undefined}
                  aria-describedby={
                    errors.password ? "password-error" : undefined
                  }
                />
                <InputError id="password-error" messages={errors.password} />
              </div>

              <Button
                type="submit"
                className="mt-4 w-full"
                disabled={processing}
              >
                {processing && <Spinner />}
                Log in
              </Button>
            </div>

            <p className="text-muted-foreground text-center text-sm">
              Have an invite link?{" "}
              <TextLink href={signUpPath()}>Create an account</TextLink>
            </p>
          </>
        )}
      </Form>
    </AuthLayout>
  )
}
